<template>
  <base-modal>
    <z-form ref="form" class="z-form z-form--vertical" @submit.native.prevent="save">
      <z-form-group class="row mb-3">
        <div class="col-12">
          <z-form-input :rules="{ required: true, max: 255 }" :show_errors="false">
            <i-input v-model="form.name" />
          </z-form-input>
        </div>
      </z-form-group>

      <z-form-group class="row mb-0">
        <div class="col-12">
          <z-form-input :rules="{ required: true }" :show_errors="false">
            <message-input v-model="form.body" />
          </z-form-input>
        </div>
      </z-form-group>
    </z-form>

    <i-button
      slot="footer-ok"
      type="success"
      size="large"
      :loading="is_button_loading"
      @click="save"
    >
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import MessageInput from '@shared/components/input/input-sms-textarea';
  import defaultsDeep from 'lodash-es/defaultsDeep';
  import cloneDeep from 'lodash-es/cloneDeep';
  import { TemplateService } from '@mailer/services/TemplateService';
  import { isID } from '@shared/helpers/uid';

  export default {
    components: {
      BaseModal,
      MessageInput
    },

    props: {
      id: {
        type: [Number, String],
        default: undefined
      },

      item: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      form: {},
      is_button_loading: false
    }),

    watch: {
      item: {
        handler: function(val) {
          this.form = cloneDeep(
            defaultsDeep(val, {
              name: '',
              body: ''
            })
          );
        },
        immediate: true,
        deep: true
      }
    },

    methods: {
      save: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            this.is_button_loading = true;

            const request = isID(this.id)
              ? TemplateService.editItem(this.id, this.form)
              : TemplateService.createItem(this.form);

            request
              .then(res => this.$emit('success', res))
              .catch(e => {
                this.$noty.server_error(e);
                this.$emit('fail', e);
              })
              .finally(() => (this.is_button_loading = false));
          }
        });
      }
    }
  };
</script>
